import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";

export const postEndLiveAgentChat = createAsyncThunk<
  void
>(
  "chat-slice/post-end-live-agent-chat",
  async (
    _,
    { getState, signal, rejectWithValue, fulfillWithValue }
  ) => {
    const state = getState() as RootState;
    const { sessionId,conversationId,suId,merchId } = state["app-state"];

    const reqBody = {
      session_id: sessionId,
      conversation_id: conversationId,
      su_id: suId,
      merch_id: merchId,
    }

    const response = await axiosClient.post(
      "/user/end_chat",
      reqBody,
      { signal },
    );
    if (response.status !== HttpStatusCode.Ok) {
      // Return the known error for future handling
      return rejectWithValue(response.data);
    }

    return fulfillWithValue(response.data);
  }
);
